import React from 'react';

class Videoplayer extends React.Component {
    render() {
        const { vimeoId, width, height } = this.props;
        return (
            <div className="videoplayer">
                <iframe src={`https://player.vimeo.com/video/${vimeoId}?title=0&byline=0`} style={{ width: width, height: height }} width={width} height={height} frameborder="0" allow="autoplay"></iframe>
            </div>
        )
    }
}

module.exports = Videoplayer;


// WEBPACK FOOTER //
// ./src/main/resources/site/parts/videoplayer/Component/index.jsx